module.exports = __webpack_public_path__ + "static/media/cross.2a94cb9b.svg";